export default __webpack_public_path__ + "static/media/f7ff2275264f7255bb8ddca9f6e80a7c.md";